module.exports = __webpack_public_path__ + "img/it.9d809034.png";